// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tenant-administrator-enabling-customer-user-container{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50vh;
}
.tenant-administrator-enabling-customer-user-loading-message{
    text-align: center;
}
.tenant-administrator-enabling-customer-user-loading-message p{
    font-size: 14px;
    color: rgb(80, 80, 80);
    margin-top: 16px;
}
.tenant-administrator-enabling-customer-user-loading-spinner{
    width: 32px;
    height: 32px;
    display: inline-block;
    border: 2px solid rgba(155, 30, 30, 0.953);
    border-top-color: transparent;
    border-radius: 50%;
    animation: tenant-administrator-enabling-customer-user-loading-spinner 1s linear infinite;
}
@keyframes tenant-administrator-enabling-customer-user-loading-spinner {
    to {
        transform: rotate(360deg);
    }
}
.tenant-administrator-enabling-customer-user-success-message,
.tenant-administrator-enabling-customer-user-error-message{
    text-align: center;
}
.tenant-administrator-enabling-customer-user-success-message p,
.tenant-administrator-enabling-customer-user-error-message p{
    font-size: 14px;
    color: rgb(80, 80, 80);
}
.tenant-administrator-enabling-customer-user-success-button-container,
.tenant-administrator-enabling-customer-user-error-button-container{
    text-align: right;
}
.tenant-administrator-enabling-customer-user-success-button-container button,
.tenant-administrator-enabling-customer-user-error-button-container button{
    padding: 8px 16px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
    color: white;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);
    background-color: rgba(155, 30, 30, 0.952);
    transition: opacity 0.2s ease;
}
.tenant-administrator-enabling-customer-user-success-button-container button:hover,
.tenant-administrator-enabling-customer-user-error-button-container button:hover{
    opacity: 0.9;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Customers/CustomerUsers/EnablingCustomerUser.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,yFAAyF;AAC7F;AACA;IACI;QACI,yBAAyB;IAC7B;AACJ;AACA;;IAEI,kBAAkB;AACtB;AACA;;IAEI,eAAe;IACf,sBAAsB;AAC1B;AACA;;IAEI,iBAAiB;AACrB;AACA;;IAEI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,6BAA6B;AACjC;AACA;;IAEI,YAAY;AAChB","sourcesContent":[".tenant-administrator-enabling-customer-user-container{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50vh;\n}\n.tenant-administrator-enabling-customer-user-loading-message{\n    text-align: center;\n}\n.tenant-administrator-enabling-customer-user-loading-message p{\n    font-size: 14px;\n    color: rgb(80, 80, 80);\n    margin-top: 16px;\n}\n.tenant-administrator-enabling-customer-user-loading-spinner{\n    width: 32px;\n    height: 32px;\n    display: inline-block;\n    border: 2px solid rgba(155, 30, 30, 0.953);\n    border-top-color: transparent;\n    border-radius: 50%;\n    animation: tenant-administrator-enabling-customer-user-loading-spinner 1s linear infinite;\n}\n@keyframes tenant-administrator-enabling-customer-user-loading-spinner {\n    to {\n        transform: rotate(360deg);\n    }\n}\n.tenant-administrator-enabling-customer-user-success-message,\n.tenant-administrator-enabling-customer-user-error-message{\n    text-align: center;\n}\n.tenant-administrator-enabling-customer-user-success-message p,\n.tenant-administrator-enabling-customer-user-error-message p{\n    font-size: 14px;\n    color: rgb(80, 80, 80);\n}\n.tenant-administrator-enabling-customer-user-success-button-container,\n.tenant-administrator-enabling-customer-user-error-button-container{\n    text-align: right;\n}\n.tenant-administrator-enabling-customer-user-success-button-container button,\n.tenant-administrator-enabling-customer-user-error-button-container button{\n    padding: 8px 16px;\n    border-radius: 5px;\n    border: none;\n    cursor: pointer;\n    color: white;\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.4);\n    background-color: rgba(155, 30, 30, 0.952);\n    transition: opacity 0.2s ease;\n}\n.tenant-administrator-enabling-customer-user-success-button-container button:hover,\n.tenant-administrator-enabling-customer-user-error-button-container button:hover{\n    opacity: 0.9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
